import {config} from "../utils/Constants";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";
import axios from "axios";

const initialState = {
    loading: "idle",
    branches: [],
    error: null
};

const URL = config.url;

export const fetchBranches = createAsyncThunk(
    "Branch/GetBranches",
    async () => {
        const req = new BaseRequest(sessionStorage.getItem("SessionID"));
        const res = await axios.post(
            `${URL}/v1/Branch/GetBranches`,
            req,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("Token"),
                }
            }
        );
        return res.data;
    }
);

const branchesSlice = createSlice({
    name: "branches",
    initialState,
    reducers: {

    },
    extraReducers: (builder)=>{
        builder.addCase(fetchBranches.pending, (state) => {
            if (state.loading === "idle") {
                state.loading = "pending";
            }
        });
        builder.addCase(fetchBranches.fulfilled, (state, action) => {
            if (state.loading === "pending") {
                state.loading = "idle";
                // state.regions = [...action.payload.Payload.Regions];
                state.branches = [...action.payload.Payload.PortalBranches];
                // state.lstTills = [...action.payload.Payload.Tills];
            }
        });
        builder.addCase(fetchBranches.rejected, (state, action) => {
            if (state.loading === "pending") {
                state.loading = "idle";
                state.branches = [];
                state.regions = [];
                state.lstTills = [];
                state.error = action.error;
            }
        });
    }
})

export default branchesSlice.reducer;